import { useContext } from 'react'
import { toast } from 'react-toastify'

import { useRealtimeSubscription, useThunkDispatch } from '@domain-group/react-hooks'
import * as invoiceItemActions from '@redux/modules/invoiceItem'

import RealtimeContext from '@contexts/realtimeContext'

import { AppDispatch } from '@redux/store'

import type { InvoiceItemModel } from '@models/types'

export type InvoiceItemResult = {
  filters: object,
  options: {
    event_type: 'update' | 'delete',
  },
  payload: InvoiceItemModel,
}

type ProcessCopyAgencyDataParams = {
  closeModal: () => void,
  data: InvoiceItemResult,
  dispatch: AppDispatch,
}

export const processInvoiceItem = (params: ProcessCopyAgencyDataParams) => {
  const { closeModal, data, dispatch } = params
  const { payload: invoiceItem, options } = data
  const { event_type } = options || {}

  if (event_type === 'delete'){
    toast('Item Deleted Successfully')

    const { removeInvoiceItemFromStore } = invoiceItemActions

    dispatch(removeInvoiceItemFromStore(invoiceItem))
    closeModal()
  }
}

type Options = {
  callbacks: {
    closeModal: () => void,
  },
}

const useInvoiceItemActions = (invoiceItem: InvoiceItemModel, options: Options) => {
  const { callbacks: { closeModal } } = options

  const realtimeContext = useContext(RealtimeContext)
  // @ts-expect-error TS2339
  const { clientRef } = realtimeContext

  const dispatch = useThunkDispatch()

  useRealtimeSubscription({
    apiKey: process.env.REACT_APP_ABLY_PUBLIC_KEY,
    callbacks: {
      success: (data: InvoiceItemResult) => processInvoiceItem({ closeModal, data, dispatch }),
    },
    channelName: 'invoiceItems',
    clientRef,
    eventName: `invoiceItem.${invoiceItem.id}.mutated`,
  }, [invoiceItem.id])
}

export default useInvoiceItemActions
